<div class="outdated-version-banner" *ngIf="outdated$ | async" role="alert">
  <span class="outdated-version-banner__message">
    <strong>A new version of PatientGo is available.</strong> You are using an outdated version - please refresh to update.
  </span>
  <app-button text="Reload" size="sm" (clicked)="reload()"></app-button>
</div>
